import { WorkingPasscodeList } from '@/types/passcode-list.types';
import { ManuallyAddedUser } from '@/types/passcode-list.types';
import { PASSCODE_LIST_TYPE } from '@/types/registration.types';

const defaultPasscodeList: WorkingPasscodeList = {
  type: PASSCODE_LIST_TYPE.EMAILS_ONLY,
  name: '',
  max_uses: 0,
  master_passcode: '',
  url: '',
  manually_added_users: [{ email: '', first_name: '', last_name: '' }] as ManuallyAddedUser[],
};

export default defaultPasscodeList;
